import styles from "./Footer.module.scss";

export const Footer = (): JSX.Element => {
  return <div className={styles["footer"]}>Bethlehem university</div>;
};
